import { render, staticRenderFns } from "./ExternalExpertEdit.vue?vue&type=template&id=587574ca&scoped=true"
import script from "./ExternalExpertEdit.vue?vue&type=script&lang=js"
export * from "./ExternalExpertEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587574ca",
  null
  
)

export default component.exports